(function () {
  if (window.FFCartDrawer && window.FFCartDrawer.nativeBundlingV2) return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cartUrl = root + 'cart';
  var refreshPromise = null;
  var openAfterRefresh = false;
  var cartAddBusyTimer = null;
  var addPending = false;
  var addPendingTimer = null;
  var pendingButton = null;
  var pendingButtonOriginal = null;
  var pendingButtonIsInput = false;
  var activeOfferTrigger = null;

  function updateCount(value) {
    document.querySelectorAll('[data-cart-count]').forEach(function (count) {
      count.textContent = value;
    });
  }

  function hideThemeLoading() {
    document.querySelectorAll('.loading-modal').forEach(function (modal) {
      if (window.jQuery) {
        window.jQuery(modal).stop(true, true).hide();
      } else {
        modal.style.display = 'none';
      }
    });
  }

  function hideSuccessPopup() {
    document.querySelectorAll('[data-ajax-cart-success]').forEach(function (modal) {
      if (window.jQuery) {
        window.jQuery(modal).stop(true, true).hide();
      } else {
        modal.style.display = 'none';
      }
    });

    document.documentElement.classList.remove('halo-modal-open');
    document.documentElement.style.overflow = '';
  }

  function openDrawer() {
    var dropdown = document.getElementById('dropdown-cart');
    if (!dropdown) return;

    hideSuccessPopup();

    var wrapper = dropdown.closest('.wrapper-top-cart');
    var defaultDesktop = window.innerWidth >= 1200 &&
      !!document.querySelector('.site-header.header-default') &&
      !!wrapper;

    if (defaultDesktop) {
      wrapper.classList.add('is-open');
      dropdown.style.display = 'block';
      document.documentElement.classList.remove('cart-show');
    } else {
      document.documentElement.classList.add('cart-show');
    }
  }

  function setDrawerBusy(busy) {
    var dropdown = document.getElementById('dropdown-cart');
    if (!dropdown) return;

    dropdown.classList.toggle('ff-cart-adding', !!busy);
    dropdown.setAttribute('aria-busy', busy ? 'true' : 'false');
    window.clearTimeout(cartAddBusyTimer);

    if (busy) {
      cartAddBusyTimer = window.setTimeout(function () {
        setDrawerBusy(false);
      }, 8000);
    }
  }

  function showPendingNotice() {
    var dropdown = document.getElementById('dropdown-cart');
    if (!dropdown) return;

    var notice = dropdown.querySelector('[data-ff-cart-pending]');
    if (!notice) {
      notice = document.createElement('div');
      notice.className = 'ff-cart-pending';
      notice.setAttribute('data-ff-cart-pending', '');
      notice.setAttribute('role', 'status');
      notice.setAttribute('aria-live', 'polite');
      notice.innerHTML = '<span class="ff-cart-pending__spinner" aria-hidden="true"></span><span><strong>Adding to cart…</strong><small>Please wait while your item is added.</small></span>';

      var title = dropdown.querySelector('.cart-title');
      if (title) {
        title.insertAdjacentElement('afterend', notice);
      } else {
        dropdown.insertBefore(notice, dropdown.firstChild);
      }
    }
  }

  function lockAddButton(button) {
    if (addPending) return false;

    addPending = true;
    pendingButton = button || null;

    if (pendingButton) {
      pendingButtonIsInput = pendingButton.tagName === 'INPUT';
      pendingButtonOriginal = pendingButtonIsInput ? pendingButton.value : pendingButton.innerHTML;
      pendingButton.classList.add('ff-add-pending');
      pendingButton.setAttribute('aria-disabled', 'true');

      if (pendingButtonIsInput) {
        pendingButton.value = 'Adding…';
      } else {
        pendingButton.textContent = 'Adding…';
      }
    }

    window.clearTimeout(addPendingTimer);
    addPendingTimer = window.setTimeout(releaseAddButton, 15000);
    return true;
  }

  function releaseAddButton() {
    addPending = false;
    window.clearTimeout(addPendingTimer);

    if (pendingButton) {
      pendingButton.classList.remove('ff-add-pending');
      pendingButton.removeAttribute('aria-disabled');

      if (pendingButtonIsInput) {
        pendingButton.value = pendingButtonOriginal;
      } else {
        pendingButton.innerHTML = pendingButtonOriginal;
      }
    }

    pendingButton = null;
    pendingButtonOriginal = null;
    pendingButtonIsInput = false;

    var notice = document.querySelector('#dropdown-cart [data-ff-cart-pending]');
    if (notice) notice.remove();
  }

  function showAddingState() {
    hideThemeLoading();
    hideSuccessPopup();
    setDrawerBusy(true);

    var dropdown = document.getElementById('dropdown-cart');
    var wrapper = dropdown && dropdown.closest('.wrapper-top-cart');
    var drawerIsOpen = document.documentElement.classList.contains('cart-show') ||
      !!(wrapper && wrapper.classList.contains('is-open'));

    if (drawerIsOpen) {
      showPendingNotice();
    }
  }

  function replaceDrawer(html) {
    var current = document.getElementById('dropdown-cart');
    if (!current) return;

    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.getElementById('dropdown-cart');

    if (!fresh) {
      current.innerHTML = html;
      return;
    }

    var count = fresh.getAttribute('data-ff-cart-count');
    current.innerHTML = fresh.innerHTML;
    current.setAttribute('data-ff-cart-count', count || '0');

    if (count !== null) {
      updateCount(count);
    }
    setDrawerBusy(false);
  }

  function refresh(shouldOpen) {
    openAfterRefresh = openAfterRefresh || !!shouldOpen;
    if (refreshPromise) return refreshPromise;

    refreshPromise = fetch(cartUrl + '?view=ajax', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'Accept': 'text/html' }
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart drawer refresh failed');
      return response.text();
    })
    .then(function (html) {
      replaceDrawer(html);
      if (openAfterRefresh) openDrawer();
      return html;
    })
    .finally(function () {
      refreshPromise = null;
      openAfterRefresh = false;
      setDrawerBusy(false);
      releaseAddButton();
    });

    return refreshPromise;
  }

  function removeNativeLine(row, link) {
    var key = row && row.getAttribute('data-ff-line-key');
    if (!key) return;

    link.style.pointerEvents = 'none';
    link.style.opacity = '0.5';

    fetch(cartUrl + '/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart update failed');
      return response.json();
    })
    .then(function (cart) {
      updateCount(cart.item_count);
      return refresh(true);
    })
    .catch(function () {
      window.location.href = cartUrl;
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var cartToggle = target.closest('[data-cart-toggle]');
    if (!cartToggle) return;

    event.preventDefault();
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var addButton = target.closest('#product-add-to-cart, [data-sticky-btn-addToCart], [data-btn-addtocart], .add-to-cart-btn, button[name="add"], input[name="add"]');
    if (!addButton || addButton.disabled) return;

    var productForm = addButton.closest('form[action*="/cart/add"]');
    if (!productForm) return;
    if (productForm.checkValidity && !productForm.checkValidity()) return;

    if (addPending) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }

    lockAddButton(addButton);
    showAddingState();
  }, true);

  document.addEventListener('click', function (event) {
    var removeLink = event.target.closest('#dropdown-cart .btn-remove');
    if (!removeLink) return;

    var row = removeLink.closest('li[data-ff-line-key]');
    if (!row) return;

    event.preventDefault();
    event.stopPropagation();
    removeNativeLine(row, removeLink);
  });

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('#dropdown-cart [data-ff-offers-open]');
    if (opener) {
      var dialog = document.getElementById(opener.getAttribute('aria-controls'));
      if (!dialog) return;
      activeOfferTrigger = opener;
      if (!dialog.open && typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
      return;
    }

    var closer = event.target.closest('#dropdown-cart [data-ff-offers-close]');
    var openDialog = event.target.closest('#dropdown-cart [data-ff-offers-dialog]');
    if (closer || (openDialog && event.target === openDialog)) {
      var dialogToClose = closer ? closer.closest('dialog') : openDialog;
      if (typeof dialogToClose.close === 'function') dialogToClose.close();
      else dialogToClose.removeAttribute('open');
      if (activeOfferTrigger && typeof activeOfferTrigger.focus === 'function') activeOfferTrigger.focus();
      activeOfferTrigger = null;
      return;
    }

    var offerButton = event.target.closest('#dropdown-cart [data-ff-apply-offer]');
    if (!offerButton || offerButton.disabled) return;

    var code = offerButton.getAttribute('data-discount-code');
    if (!code) return;

    offerButton.disabled = true;
    offerButton.textContent = 'Applying…';

    fetch(cartUrl + '/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ discount: code })
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Discount request failed');
      return response.json();
    })
    .then(function (cart) {
      var discounts = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
      var applied = discounts.some(function (discount) {
        return String(discount.code || '').toLowerCase() === code.toLowerCase() &&
          discount.applicable !== false;
      });
      offerButton.textContent = applied ? 'Applied' : 'Saved';
      return refresh(true);
    })
    .catch(function () {
      offerButton.disabled = false;
      offerButton.textContent = 'Try again';
    });
  });

  function isCartAddRequest(url, method) {
    if (String(method || 'GET').toUpperCase() !== 'POST') return false;

    try {
      var parsedUrl = new URL(String(url || ''), window.location.origin);
      return /\/cart\/add(?:\.js)?\/?$/.test(parsedUrl.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:\?|$)/.test(String(url || ''));
    }
  }

  function afterSuccessfulCartAdd(cart) {
    hideThemeLoading();
    hideSuccessPopup();
    if (cart && typeof cart.item_count === 'number') {
      updateCount(cart.item_count);
    }

    refresh(true).catch(function () {
      hideThemeLoading();
      setDrawerBusy(false);
      releaseAddButton();
      document.documentElement.classList.remove('cart-show');
    });
  }

  if (window.jQuery) {
    var $document = window.jQuery(document);

    $document
      .off('ajaxSend.ffNativeBundling')
      .on('ajaxSend.ffNativeBundling', function (event, xhr, settings) {
        var method = settings && (settings.type || settings.method);
        var url = settings && settings.url;
        if (!isCartAddRequest(url, method)) return;
        showAddingState();
      })
      .off('ajaxSuccess.ffNativeBundling')
      .on('ajaxSuccess.ffNativeBundling', function (event, xhr, settings) {
        var method = settings && (settings.type || settings.method);
        var url = settings && settings.url;

        if (!isCartAddRequest(url, method)) return;
        afterSuccessfulCartAdd(xhr && xhr.responseJSON);
      })
      .off('ajaxError.ffNativeBundling')
      .on('ajaxError.ffNativeBundling', function (event, xhr, settings) {
        var method = settings && (settings.type || settings.method);
        var url = settings && settings.url;
        if (!isCartAddRequest(url, method)) return;
        hideThemeLoading();
        setDrawerBusy(false);
        releaseAddButton();
        document.documentElement.classList.remove('cart-show');
      });
  }

  if (window.fetch && !window.fetch.__ffNativeBundlingObserver) {
    var nativeFetch = window.fetch;

    var observedFetch = function (input, init) {
      var requestUrl = typeof input === 'string' ? input : (input && input.url) || '';
      var requestMethod = (init && init.method) || (input && input.method) || 'GET';
      var isAddRequest = isCartAddRequest(requestUrl, requestMethod);

      if (isAddRequest) {
        showAddingState();
      }

      var requestPromise = nativeFetch.apply(this, arguments);

      if (isAddRequest) {
        requestPromise
          .then(function (response) {
            if (response && response.ok) {
              response.clone().json().then(afterSuccessfulCartAdd).catch(function () {
                afterSuccessfulCartAdd();
              });
            }
          })
          .catch(function () {
            hideThemeLoading();
            setDrawerBusy(false);
            releaseAddButton();
            document.documentElement.classList.remove('cart-show');
          });
      }

      return requestPromise;
    };

    observedFetch.__ffNativeBundlingObserver = true;
    observedFetch.__ffNativeBundlingOriginal = nativeFetch;
    window.fetch = observedFetch;
  }
  window.FFCartDrawer = {
    initialized: true,
    nativeBundling: true,
    nativeBundlingV2: true,
    refresh: refresh,
    open: openDrawer
  };
})();
